export default {
  zh: {
    establish: "设立信息",
    yearTitle: "财务年度 (举例：12月31日)",
    periodTitle: "财务期间",
    capitalTitle: "股本信息",
    shareholderName: "股东名称",
    registeredTitle: "公司注册地址",
    regOptionMain: "我们同意采用星中商务的注册地址",
    otherMain: "采用其他注册地址 (须英文输入)",
    otherMinor: "新设公司提供的优惠套餐收费不因注册地址未使用星中商务的注册地址而减免",
    otherTransferMinor: "对拟转移公司提供的优惠套餐收费不因注册地址未使用星中商务的注册地址而减免",
    address: "地址:",
    city: "城市:",
    country: "国家:",
    code: "邮编:",
    hoursTitle: "工作时长",
    hoursOption01: "每个工作日的正常工作时间至少 5 小时",
    hoursOption02: "每个工作日的正常工作时间至少3小时但少于5小时",
    constitutionTitle: "公司章程",
    constitutionOption01: "标准章程",
    constitutionOption02: "定制化章程(该选项下需要申请人在下一步骤上传经律师复核的定制化章程)",
    authoritiesTitle: "行业性质是否特殊、是否已取得相关其他政府机构的批准？",
    assist: "不清楚，需要星中商务协助确认",
    month: "月",
    date: "日",
    EPInfo: "EP签证信息",
    addEPApplicant: "添加EP申请人",
    editEPApplicant: "编辑EP申请人",
  },
  en: {
    establish: "Company Details",
    yearTitle: "Financial Year End (e.g. 31 December)",
    periodTitle: "Financial Year Period",
    capitalTitle: "Share Capital Details",
    shareholderName: "Name of shareholder",
    registeredTitle: "Registered Office",
    regOptionMain: 'Consent to use EStar Business Services Pte. Ltd. ("EStar")\'s registration address',
    otherMain: "Use other registration address (English Only)",
    otherMinor: "EStar's service fee will not be reduced nor waived due to this choice.",
    otherTransferMinor: "EStar's service fee will not be reduced nor waived due to this choice.",
    address: "Address:",
    city: "City:",
    country: "Country:",
    code: "Code:",
    hoursTitle: "Working hours",
    hoursOption01: "At least 5 hours during ordinary business hours on each business day",
    hoursOption02: "At least 3 hours but less than 5 hours during ordinary business hours on each business day",
    constitutionTitle: "Constitution",
    constitutionOption01: "Standard constitution",
    constitutionOption02: "Customized constitution (customized constitution reviewed by legal is required to be uploaded in the next step under this option)",
    authoritiesTitle: "Is the company's business special and needs to obtain approval(s) from specific government authorities?",
    assist: "Uncertain, need EStar's assistance",
    month: "Month",
    date: "Date",
    EPInfo: "EP Info",
    addEPApplicant: "Add EP Applicant",
    editEPApplicant: "Edit EP Applicant",
  },
};
